type Item = { processing: boolean; name?: string; versions?: Data };
type Data = readonly Item[];

function itemProcessing(item: Item): boolean {
	if (item.processing) return true;

	if (item.versions) return shareVisualsProcessing(item.versions);

	return false;
}

// Backend can occasionally return duplicate version entries with the same name.
// In some cases one duplicate is already processed while another remains `processing: true`.
// We group duplicate version names and treat the group as not processing if any duplicate
// is already done, so the UI does not keep polling indefinitely on stale duplicates.
export function shareVisualsProcessing(shareVisualData: Data): boolean {
	const groupedByName = new Map<string, Item[]>();

	return (
		shareVisualData.some((item) => {
			if (!item.name) return itemProcessing(item);

			const group = groupedByName.get(item.name);
			if (!group) {
				groupedByName.set(item.name, [item]);
				return false;
			}

			group.push(item);
			groupedByName.set(item.name, group);
			return false;
		}) ||
		Array.from(groupedByName.values()).some((group) => {
			if (group.length === 1) return itemProcessing(group[0]);

			if (group.some((item) => !item.processing)) return false;

			return group.some(itemProcessing);
		})
	);
}
